import { useEffect, useState } from "react"
import {
  AvForm,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation"
import { Row } from "reactstrap"
import AvInput from "availity-reactstrap-validation/lib/AvInput"

import Application from "services/applications/Application.service"
let officerInfo = JSON.parse(localStorage.getItem("authUser"))
let appService = new Application(officerInfo)

const OfficerFormLicense = props => {
  const [officerSubmitted, setofficerSubmitted] = useState(false)
  const [showComments, setshowComments] = useState()
  const [comments, setcomments] = useState()
  const [uploadFile, setuploadFile] = useState()

  // useEffect(()=>{
  //     console.log("---------", props.appDetails)
  // }, [])

  const decisionValueChange = value => {
    const commentsCodes = ["011", "012"]
    if (commentsCodes.includes(value)) {
      setshowComments(true)
    } else {
      setcomments("")
      setshowComments(false)
    }
  }

  const uploadSignedNotification = () => {
    console.log(uploadFile)
    if(uploadFile === undefined) {
        alert("please select upload document")
    } else {
      const upload = {
          application_id: props.appDetails.id,
          name: "Signed_notification_by_two_countries",
          file: uploadFile
      }
      appService.uploadFile(upload).then(response=>{
          console.log(response)
          if(response.status) {
              alert("Signed Notification Uploaded successfully")
          }
      })
    }

  }

  return (
    <>
      <div>
        <AvField
          type="hidden"
          name="application_id"
          value={props.appDetails.id}
        />
      </div>

      <div className="mb-3">
        <AvField
          disabled={officerSubmitted}
          type="select"
          name="decision_code"
          label="Select Decision"
          //value={defaultValues.decision_code}
          required
          onChange={v => {
            decisionValueChange(v.target.value)
          }}
        >
          <option value="">--select Decision--</option>
          <option value="010">Propose to Approve</option>

          <option value="011">Propose to Reject</option>
          <option value="012">Return to Applicant</option>
        </AvField>
      </div>

      <Row className="mb-3">
        <label htmlFor="reason" className="col-lg-3 col-form-label">
          Reason
        </label>
        <div className="col-lg-9">
          <AvField
            disabled={officerSubmitted}
            type="textarea"
            //value={defaultValues.reason}
            id="reason"
            name="reason"
            rows="2"
            required
            className="form-control"
          ></AvField>
        </div>
      </Row>

      {showComments ? (
        <Row className="mb-3">
          <label
            htmlFor="comment_to_applicant"
            className="col-lg-3 col-form-label"
          >
            Comments to applicant
          </label>
          <div className="col-lg-9">
            <AvField
              disabled={officerSubmitted}
              type="textarea"
              id="comment_to_applicant"
              name="comment_to_applicant"
              //value={defaultValues.comment_to_applicant}
              rows="4"
              required
              className="form-control"
              onChange={v => {
                //setcomments(v.target.value)
              }}
            ></AvField>
          </div>
        </Row>
      ) : null}

      {/* If license type is export, make room for officers to upload signed notification by two countries */}
      {props.appDetails.service_id === 4 ? (
        <Row>
          <hr></hr>
          <table className="table table-responsive table-striped">
            <tbody>
              {/* <form
                onSubmit={e => {
                  e.preventDefault()
                  uploadSignedNotification(e)
                }}
              > */}
                <tr>
                  <td>Upload Signed Notification Between Two Countries</td>
                  <td>
                    <input
                      className="form-control btn-info"
                      type="file"
                      id="signed_document"
                      accept=".doc,.docx"
                      onChange={(e)=>{
                        setuploadFile(e.target.files[0])
                      }}
                    />
                  </td>
                  <td>
                    <button
                      className="btn btn-warning"
                      onClick={uploadSignedNotification}
                    >
                      Upload
                    </button>
                  </td>
                </tr>
              {/* </form> */}
            </tbody>
          </table>
        </Row>
      ) : null}

      <div className="mt-5">
        <button
          className="btn btn-lg btn-primary col-12"
          disabled={officerSubmitted}
        >
          Submit Review
        </button>
      </div>
    </>
  )
}

export default OfficerFormLicense
